var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("body", { staticClass: "akl" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "renew-compliance" },
      [
        _c("div", { staticClass: "general-header" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container amway-theme", attrs: { id: "contents" } },
          [
            _c("h1", { staticClass: "title-h2" }, [
              _vm._v("ABO 약관 및 개인정보 동의")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "compliance-area privacy" }, [
              _c("div", { staticClass: "termsWrapper" }, [
                _c("div", { staticClass: "col-search-tab link-to" }, [
                  _c("span", {
                    staticClass: "scrollable-area left",
                    staticStyle: { display: "none" }
                  }),
                  _c("span", {
                    staticClass: "scrollable-area right",
                    staticStyle: { display: "none" }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "tabWrapper" }, [
                    _c("ul", { staticClass: "width-auto" }, [
                      _c("li", { staticClass: "active" }, [
                        _c(
                          "a",
                          {
                            attrs: { "data-toggle": "tab" },
                            on: {
                              click: function($event) {
                                return _vm.scrollToElement("titNo01")
                              }
                            }
                          },
                          [_vm._v("이용약관")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.scrollToElement("titNo02")
                              }
                            }
                          },
                          [_vm._v("계약 동의서")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.scrollToElement("titNo03")
                              }
                            }
                          },
                          [_vm._v("유의사항")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.scrollToElement("titNo04")
                              }
                            }
                          },
                          [_vm._v("개인정보 이용")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.scrollToElement("titNo06")
                              }
                            }
                          },
                          [_vm._v("개인정보 제공")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.scrollToElement("titNo07")
                              }
                            }
                          },
                          [_vm._v("마케팅/홍보")]
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _c(
                      "strong",
                      {
                        ref: "titNo01",
                        staticClass: "titH1 txt-titH1",
                        attrs: { id: "titNo01" }
                      },
                      [_vm._v("[필수] 전자상거래에 관한 이용약관")]
                    ),
                    _vm._v(" "),
                    _vm._m(1)
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c(
                      "strong",
                      {
                        ref: "titNo02",
                        staticClass: "titH1 txt-titH1",
                        attrs: { id: "titNo02" }
                      },
                      [_vm._v("[필수] ABO 계약 동의서")]
                    ),
                    _vm._v(" "),
                    _vm._m(2)
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c(
                      "strong",
                      {
                        ref: "titNo03",
                        staticClass: "titH1 txt-titH1",
                        attrs: { id: "titNo03" }
                      },
                      [_vm._v("[필수] ABO 유의사항")]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "titH2 bgNone" }, [
                      _vm._v(
                        "본인은 한국암웨이 ABO로 활동하고자 본 신청서를 제출함에 있어 다음의 사항을 숙지하고 성실히 준수할 것에 동의합니다."
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(3),
                    _vm._v(" "),
                    _c("p", { staticClass: "titH2 mgtL" }, [
                      _vm._v("다단계 판매원 (ABO)의 금지행위")
                    ]),
                    _vm._v(" "),
                    _vm._m(4),
                    _vm._v(" "),
                    _c("p", { staticClass: "titH2 mgtL" }, [
                      _vm._v("상품의 판매가격 또는 용역의 대가")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "titHtext" }, [
                      _vm._v(
                        "한국암웨이에서 판매되는 모든 상품의 판매가격 또는 용역의 대가는 회사에서 발행하는 제품 카탈로그 또는 Amway 사이트(www.amway.co.kr)를 참조하시면 됩니다. 자세한 문의는 한국암웨이 고객센터(1588-0080)로 문의하시기 바랍니다."
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "titH2 mgtL" }, [
                      _vm._v("상품대금 또는 용역대가의 지급시기 및 방법")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "titHtext" }, [
                      _vm._v(
                        "한국암웨이 제품을 구입하고자 하는 ABO는 인터넷(www.amway.co.kr), 모바일 Amway 앱, 전화주문을 통해 배달주문이 가능하며, 전국 암웨이 비즈니스 센터에 직접 내방하여 주문 및 결제가 가능합니다. 제품 대금은 신용카드, 자동이체, A포인트/Re-cash, 현금(암웨이 비즈니스 센터), 무통장입금으로 결제하는 방법이 있습니다. 배달 주문의 경우 주문 시 신청된 주소지로 배달이 되며, 6만원 미만의 경우 배달 수수료가 발생할 수 있습니다. 그 외 기타 자세한 주문 방법은 Amway 사이트(www.amway.co.kr)및 관련 카탈로그를 참조하십시오."
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "titH2 mgtL" }, [
                      _vm._v("상품의 인도시기 또는 용역의 제공시기")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "titHtext" }, [
                      _vm._v(
                        "암웨이 비즈니스 센터(ABC)에서 직접 주문할 경우, 현장에서 즉시 주문품을 수령할 수 있으며 배달주문의 경우, 주문대금의 지불 확인 후 주문을 확정하는 시점부터 통상 1일부터 5일 사이에 주문 시 신청된 주소지로 배달됩니다. 참고로 배달 소요일자 계산에서 일요일과 공휴일은 제외된다는 것을 유의 하십시오. 주문 제품의 인도에 관한 기타 상세한 정보는 Amway 사이트(www.amway.co.kr) 및 관련 카탈로그를 참조하십시오."
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "titH2 mgtL" }, [
                      _vm._v("상품의 품질보증 및 사후 관리에 관한 사항")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "titHtext" }, [
                      _vm._v(
                        '암웨이"소비자만족 보증제도"와 기타"품질보증서"에 따라 암웨이 제품을 구입한 소비자의 보호와 품질보증에 만전을 기하고 있습니다. 암웨이"소비자만족 보증제도"는 암웨이 제품을 사용한 소비자가 제품의 품질에 만족하지 못해 반환한 경우, 제품대금의 환불이나 다른 제품으로 교환해주는 소비자 보호제도입니다. 그러나 고의나 자신의 부주의로 손상된 제품에 대해서는 본 제도가 적용되지 않습니다. 이와 함께 일부 제품에는"소비자보호법"제 8조에 의거 품질표시에 관한 내용과 품질보증조건 및 부품보유기간을 표시한 품질보증서를 첨부하여 동 제품사용으로 인한 소비자피해를 보상하고 있습니다. 아울러, 품질보증서가 없을 경우에"소비자피해보상규정"(공정거래위원회 고시 제2008-3호) 제 5조에 의거, 관련 유사제품의 보상기준에 준해 보상해 드립니다.'
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "txt-italic" }, [
                      _vm._v(
                        "원 포 원 제품과 일부 제품의 경우 일반 반품규정이 상이하오니, 제품 카탈로그를 참조하십시오."
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "titH2 mgtL" }, [
                      _vm._v("다단계판매원의 탈퇴")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "titHtext" }, [
                      _vm._v(
                        "ABO 등록 후 탈퇴를 희망할 경우에는 언제든지 온라인 Amway 사이트(www.amway.co.kr)에서 본인확인 후 탈퇴하시거나, 암웨이 비즈니스 센터(ABC) 또는 고객센터에 탈퇴 신청서를 제출하시면 됩니다. ABO 탈퇴 ABO등록증 및 ABO수첩을 한국암웨이에 제출하셔야 하며, 또한 등록된 공동사업자1 휴대폰 번호로 탈퇴 안내문자 메세지가 전송됩니다. 한국암웨이는 연간 정기 갱신제도를 시행하여, ABO 자격을 계속 유지하고자 할 경우 연간 정기 갱신 기간에 암웨이에 자격 갱신을 신청해야 합니다. ABO가 유효 만기일까지 자격 갱신을 신청하지 않은 경우, 또는 암웨이가 갱신 신청을 수락하지 않는 경우 해당 ABO의 자격은 자동적으로 소멸됩니다. 또한 한국암웨이 ABO 윤리강령 및 행동지침에 의거 ABO 등록 조건을 갖추지 못한 사람이 ABO로 등록한 경우 한국암웨이의 권한에 따라 ABO 자격갱신이 거절되거나 해당 ABO 자격이 해지될 수 있습니다."
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "txt-italic" }, [
                      _vm._v(
                        "(자격갱신 대상 및 절차는 매년 발표되는 한국암웨이의 공지내용을 참조하시기 바랍니다.)"
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "titH2 mgtL" }, [
                      _vm._v("청약의 철회 및 상품 또는 용역의 반환")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "titHtext" }, [
                      _vm._v(
                        "한국암웨이로부터 구입한 상품과 용역을 반환하고자 하면 반환할 제품과 동제품의 구매사실을 입증하는 영수증을 첨부하여 한국암웨이에 제출하면 됩니다. 환불 금액은 기 지급된 보너스를 공제한 뒤 결정되고, 기 인정된 핀 레벨도 재조정됩니다. 재고반품은 구매일로부터 3개월 이내에만 허용됩니다."
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "txt-italic" }, [
                      _vm._v(
                        "* 원 포 원 제품과 일부 제품의 경우 일반 반품규정이 상이하오니, 제품 카탈로그를 참조하십시오."
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "titH2 mgtL" }, [
                      _vm._v("다단계판매와 관련한 분쟁처리에 관한 사항")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "titHtext" }, [
                      _vm._v(
                        "본 신청서와 관련하여 발생한 분쟁은 제소 당시 해당 ABO의 주소지를 관할하는 지방법원의 전속관할로 합니다. 아울러, 소비자는 소비자기본법 제55조의 규정에 의하여 한국암웨이가 판매한 물품의 사용으로 인한 피해의 구제를 한국소비자원에 청구할 수 있습니다."
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "titH2 mgtL" }, [
                      _vm._v("메일주소 필수입력사항")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "titHtext" }, [
                      _vm._v(
                        "www.amway.co.kr 사이트에서 한국암웨이(주)의 ABO 가입시 반드시 본인의 E-mail 주소를 입력하셔야 합니다. 메일주소를 입력하시지 않거나 허위로 작성시 회원가입이 이루어지지 않습니다."
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "titH2 mgtL" }, [
                      _vm._v("ABO 등록 사항 변경")
                    ]),
                    _vm._v(" "),
                    _vm._m(5),
                    _vm._v(" "),
                    _c("p", { staticClass: "txt-italic mgtS" }, [
                      _vm._v(
                        "본인 확인을 위한 신분증 지참_제 3자의 접수 진행시 사본으로 대체"
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "txt-italic point-color1" }, [
                      _vm._v(
                        "통장사본이 필요한 모든 변경건에서 대리인 접수시 온라인통장 사본 접수 불가"
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "txt-italic" }, [
                      _vm._v("모든 증명서는 발급일로부터 3개월 이내")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "txt-italic" }, [
                      _vm._v(
                        "신분증 : 주민등록증, 운전면허증, 여권(사본), 장애인 등록증 등"
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(6),
                    _vm._v(" "),
                    _c("p", { staticClass: "txt-italic mgtS" }, [
                      _vm._v("FAX : 02-538-2995")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "txt-italic mgtS" }, [
                      _vm._v(
                        "우편 : (04560) 서울특별시 중구 퇴계로 307 광희빌딩 6층 한국암웨이 고객센터"
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mgtS" }, [
                      _vm._v(
                        "본 신청서의 기재내용에 허위가 있거나, 본 신청서의 제 조항, 관련법규, 기타 한국암웨이의 윤리강령 및 제 규정을 위반한 경우 한국암웨이는 해당 ABO에게 서면 통지함으로써 ABO 자격을 해지할 수 있습니다. ABO 자격이 해지된 경우에는 즉시 ABO 자격을 상실하게 되며, 자격이 해지된 ABO는 신규가입이 제한될 수 있습니다. 해지시까지 판매하지 못한 상품은 반품규정에 의거하여 반품이 가능하며, 반품한 상품에 대해서는 기 지급된 보너스를 공제하고 대금이 환불되고, 기 인정된 핀 레벨도 재조정됩니다."
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c(
                      "strong",
                      {
                        ref: "titNo04",
                        staticClass: "titH1 txt-titH1",
                        attrs: { id: "titNo04" }
                      },
                      [_vm._v("[필수] 개인정보 수집/이용 동의서")]
                    ),
                    _vm._v(" "),
                    _vm._m(7),
                    _vm._v(" "),
                    _c("p", { staticClass: "txt-italic mgtS" }, [
                      _vm._v(
                        "마케팅 홍보 목적으로 선택적 수신동의에 따라 이메일/SMS/알림톡으로 서비스를 제공합니다."
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "txt-italic" }, [
                      _vm._v(
                        "위 정보는 가입 당시 정보뿐만 아니라 정보 수정으로 변경된 정보를 포함합니다."
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "txt-italic" }, [
                      _vm._v(
                        "필수항목은 회원 가입을 위해서 필요한 최소한 개인정보이므로 동의를 해주셔야 서비스를 이용하실 수 있습니다."
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "txt-italic" }, [
                      _vm._v(
                        "선택항목은 입력하지 않으셔도 서비스 이용에 제한이 없습니다."
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(8),
                    _vm._v(" "),
                    _vm._m(9)
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c(
                      "strong",
                      {
                        ref: "titNo06",
                        staticClass: "titH1 txt-titH1",
                        attrs: { id: "titNo06" }
                      },
                      [_vm._v("[선택] 개인정보 제 3자 제공에 대한 동의")]
                    ),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "LOS 관리, 우편물 발송, 유선상담 등 사업적으로 활용할 수 있도록 동의한 경우에 한하여, 상위 혹은 하위 ABO에게 개인정보를 제공하고 있습니다. 동의하지 않은 경우 정보 제공이 제한되며, 동의한 경우에도 언제든지 그 동의를 철회할 수 있습니다."
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(10),
                    _vm._v(" "),
                    _vm._m(11)
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c(
                      "strong",
                      {
                        ref: "titNo07",
                        staticClass: "titH1 txt-titH1",
                        attrs: { id: "titNo07" }
                      },
                      [
                        _vm._v(
                          "[선택] 마케팅/홍보 목적의 개인정보 수집 및 이용동의"
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "mgtS" }, [
                      _vm._v(
                        "마케팅/홍보를 위하여 귀하의 개인정보를 이용하는데 동의 하십니까? 동의 거부 시 제품 소개, 프로모션, 이벤트 안내 등의 마케팅/홍보 정보 제공이 제한됩니다."
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(12),
                    _vm._v(" "),
                    _vm._m(13)
                  ])
                ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("transition", { attrs: { name: "fade" } }, [
          _vm.toggle
            ? _c(
                "div",
                {
                  staticClass: "scrollTopWrapper",
                  attrs: { id: "ScrollTopArea" }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "toTop",
                      attrs: { type: "button" },
                      on: { click: _vm.scrollToTop }
                    },
                    [_vm._v("TOP(위로이동)")]
                  )
                ]
              )
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "skipToContent" } }, [
      _c("a", { attrs: { href: "#contents" } }, [_vm._v("콘텐츠 바로가기 ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "box_customer-terms" }, [
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제1조(목적)")]),
          _vm._v(" "),
          _c("p", { staticClass: "titHtext pdbNone" }, [
            _vm._v(
              "이 약관은 한국암웨이 주식회사 (전자거래 사업자)가 운영하는 한국암웨이 사이버몰 (이하 “몰”이라 한다.) 에서 제공하는 인터넷 관련 서비스(이하 “서비스”라 한다)를 이용함에 있어 사이버몰과 이용자의 권리와 의무 및 책임사항을 규정함을 목적으로 합니다."
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "listWarning" }, [
            _vm._v(
              "「PC통신, 무선 등을 이용하는 전자거래에 대해서도 그 성질에 반하지 않는 한 이 약관을 준용합니다.」"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제2조(정의)")]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰” 이란 한국암웨이 주식회사가 재화 또는 용역을 이용자에게 제공하기 위하여 컴퓨터 등 정보통신 설비를 이용하여 재화 또는 용역을 거래할 수 있도록 설정한 가상의 영업장을 말하며, 아울러 사이버 몰을 운영하는 사업자의 의미로도 사용합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “이용자”란 “몰”에 접속하여 이 약관에 따라 “몰”이 제공하는 서비스를 받는 회원 및 비회원을 말합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ ‘회원’이라 함은 “몰”에 개인정보를 제공하여 회원등록을 한 자로서, “몰”의 정보를 지속적으로 제공 받으며, “몰”이 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "④ ‘비회원’이라 함은 회원에 가입하지 않고 “몰”이 제공하는 서비스를 이용하는 자를 말합니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [
            _vm._v("제3조(약관 등의 명시와 설명 및 개정)")
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”은 이 약관의 내용과 상호 및 대표자 성명, 영업소 소재지 주소(소비자의 불만을 처리할 수 있는 곳의 주소를 포함), 전화번호·모사전송번호·전자우편주소, 사업자등록번호, 통신판매업 신고번호, 개인정보 보호책임자 등을 이용자가 쉽게 알 수 있도록 사이버몰의 초기 서비스화면(전면)에 게시합니다. 다만, 약관의 내용은 이용자가 연결화면을 통하여 볼 수 있도록 할 수 있습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”은 이용자가 약관에 동의하기에 앞서 약관에 정하여져 있는 내용 중 청약철회·배송책임·환불조건 등과 같은 중요한 내용을 이용자가 이해할 수 있도록 별도의 연결화면 또는 팝업화면 등을 제공하여 이용자의 확인을 구하여야 합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ “몰”은 「전자상거래 등에서의 소비자보호에 관한 법률」, 「약관의 규제에 관한 법률」, 「전자문서 및 전자거래기본법」, 「전자금융거래법」, 「전자서명법」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」, 「방문판매 등에 관한 법률」, 「소비자기본법」, 「개인정보 보호법」 등 관련 법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "④ “몰”이 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 몰의 초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다. 다만, 이용자에게 불리하게 약관내용을 변경하는 경우에는 최소한 30일 이상의 사전 유예기간을 두고 공지합니다. 이 경우 “몰”은 개정 전 내용과 개정 후 내용을 명확하게 비교하여 이용자가 알기 쉽도록 표시합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "⑤ “몰”이 약관을 개정할 경우에는 그 개정약관은 그 적용일자 이후에 체결되는 계약에만 적용되고 그 이전에 이미 체결된 계약에 대해서는 개정 전의 약관조항이 그대로 적용됩니다. 다만 이미 계약을 체결한 이용자가 개정약관 조항의 적용을 받기를 원하는 뜻을 제3항에 의한 개정약관의 공지기간 내에 “몰”에 송신하여 “몰”의 동의를 받은 경우에는 개정약관 조항이 적용됩니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "⑥ 이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 전자상거래 등에서의 소비자보호에 관한 법률, 약관의 규제 등에 관한 법률, 공정거래위원회가 정하는 「전자상거래 등에서의 소비자 보호지침」 및 관계법령 또는 상관례에 따릅니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [
            _vm._v("제4조(서비스의 제공 및 변경)")
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”은 다음과 같은 업무를 수행합니다.\n                                                "
              ),
              _c("ol", [
                _c("li", [
                  _vm._v(
                    "1. 재화 또는 용역에 대한 정보 제공 및 구매계약의 체결"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("2. 구매계약이 체결된 재화 또는 용역의 배송")
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("3. 기타 “몰”이 정하는 업무")])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”은 재화 또는 용역의 품절 또는 기술적 사양의 변경 등의 경우에는 장차 체결되는 계약에 의해 제공할 재화 또는 용역의 내용을 변경할 수 있습니다. 이 경우에는 변경된 재화 또는 용역의 내용 및 제공일자를 명시하여 현재의 재화 또는 용역의 내용을 게시한 곳에 즉시 공지합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ “몰”이 제공하기로 이용자와 계약을 체결한 서비스의 내용을 재화 등의 품절 또는 기술적 사양의 변경 등의 사유로 변경할 경우에는 그 사유를 이용자에게 통지 가능한 주소로 즉시 통지합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "④ 전항의 경우 “몰”은 이로 인하여 이용자가 입은 손해를 배상합니다. 다만, “몰”이 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제5조(서비스의 중단)")]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”은 컴퓨터 등 정보통신설비의 보수점검·교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”은 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여 배상합니다. 단, “몰”이 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ 사업종목의 전환, 사업의 포기, 업체 간의 통합 등의 이유로 서비스를 제공할 수 없게 되는 경우에는 “몰”은 제8조에 정한 방법으로 이용자에게 통지하고 당초 “몰”에서 제시한 조건에 따라 소비자에게 보상합니다. 다만, “몰”이 보상기준 등을 고지하지 아니한 경우에는 이용자들의 마일리지 또는 적립금 등을 “몰”에서 통용되는 통화가치에 상응하는 현물 또는 현금으로 이용자에게 지급합니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제6조(회원가입)")]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① 이용자는 “몰”이 정한 가입 양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”은 제1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각 호에 해당하지 않는 한 회원으로 등록합니다.\n                                                "
              ),
              _c("ol", [
                _c("li", [
                  _vm._v(
                    "1. 가입신청자가 이 약관 제7조 제3항에 의하여 이전에 회원자격을 상실한 적이 있는 경우, 다만 제7조 제3항에 의한 회원자격 상실 후 3년이 경과한 자로서 “몰”의 회원재가입 승낙을 얻은 경우에는 예외로 합니다."
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("2. 등록 내용에 허위, 기재누락, 오기가 있는 경우")
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "3. 기타 회원으로 등록하는 것이 “몰”의 기술상 현저히 지장이 있다고 판단되는 경우"
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ 회원가입계약의 성립시기는 “몰”의 승낙이 회원에게 도달한 시점으로 합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "④ 회원은 제15조 제1항에 의한 등록사항에 변경이 있는 경우, 즉시 전자우편 기타 방법으로 “몰”에 대하여 그 변경사항을 알려야 합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "⑤ 회원탈퇴 후 재가입시 이전에 ABO였던 회원은 6개월이 경과하여야 ABO로 재가입을 할 수 있습니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [
            _vm._v("제7조(회원 탈퇴 및 자격 상실 등)")
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① 회원은 “몰”에 언제든지 탈퇴를 요청할 수 있으며 “몰”은 즉시 회원탈퇴를 처리합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② 회원이 다음 각호의 사유에 해당하는 경우, “몰”은 회원자격을 제한 및 정지시킬 수 있습니다.\n                                                "
              ),
              _c("ol", [
                _c("li", [_vm._v("1. 가입 신청시에 허위 내용을 등록한 경우")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "2. “몰”을 이용하여 구입한 재화나 용역 등의 대금, 기타 “몰”이용에 관련하여 회원이 부담하는 채무를 기일에 지급하지 않는 경우"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "3. 다른 사람의 “몰” 이용을 방해하거나 그 정보를 도용하는 등 전자거래질서를 위협하는 경우"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "4. “몰”을 이용하여 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우"
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ “몰”이 회원 자격을 제한 또는 정지 시킨 후, 동일한 행위가 2회이상 반복되거나 30일이내에 그 사유가 시정되지 아니하는 경우 “몰”은 회원자격을 상실시킬 수 있습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "④ “몰”이 회원자격을 상실시키는 경우에는 회원등록을 말소합니다. 이 경우 회원에게 이를 통지하고, 회원등록 말소전에 일정기간(30일)을 정하여 소명할 기회를 부여합니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [
            _vm._v("제8조(회원에 대한 통지)")
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”이 회원에 대한 통지를 하는 경우, 회원이 “몰”에 제출한 전자우편 주소로 할 수 있습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”은 불특정다수 회원에 대한 통지의 경우 1주일이상 “몰” 게시판에 게시함으로서 개별 통지에 갈음할 수 있습니다. 다만, 회원 본인의 거래와 관련하여 중대한 영향을 미치는 사항에 대하여는 개별통지를 합니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제9조(구매신청)")]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”이용자는 “몰”상에서 다음 또는 이와 유사한 방법에 의하여 구매를 신청하며, “몰”은 이용자가 구매신청을 함에 있어서 다음의 각 내용을 알기 쉽게 제공하여야 합니다.\n                                                "
              ),
              _c("ol", [
                _c("li", [_vm._v("1. 재화 등의 검색 및 선택")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "2. 받는 사람의 성명, 주소, 전화번호, 전자우편주소(또는 이동전화번호) 등의 입력"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "3. 약관내용, 청약철회권이 제한되는 서비스, 배송료, 설치비 등의 비용부담과 관련한 내용에 대한 확인"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "4. 이 약관에 동의하고 위 3.호의 사항을 확인하거나 거부하는 표시(예, 마우스 클릭)"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "5. 재화 등의 구매신청 및 이에 관한 확인 또는 “몰”의 확인에 대한 동의"
                  )
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("6. 결제방법의 선택")])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”이 제3자에게 구매자 개인정보를 제공·위탁할 필요가 있는 경우 실제 구매신청 시 구매자의 동의를 받아야 하며, 회원가입 시 미리 포괄적으로 동의를 받지 않습니다. 이 때 “몰”은 제공되는 개인정보 항목, 제공받는 자, 제공받는 자의 개인정보 이용 목적 및 보유·이용 기간 등을 구매자에게 명시하여야 합니다. 다만 「개인정보 보호법」 제26조에 의한 개인정보 취급위탁의 경우 등 관련 법령에 달리 정함이 있는 경우에는 그에 따릅니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제10조(계약의 성립)")]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                " ① “몰”은 제9조와 같은 구매신청에 대하여 다음 각 호에 해당하면 승낙하지 않을 수 있습니다. 또한 “몰”은 미성년자의 가입이 불가하므로, 미성년자가 가입시 회원자격이 상실되며, 계약은 취소될 수 있습니다.\n                                                "
              ),
              _c("ol", [
                _c("li", [
                  _vm._v("1. 신청 내용에 허위, 기재누락, 오기가 있는 경우")
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "2. 기타 구매신청에 승낙하는 것이 “몰” 기술상 현저히 지장이 있다고 판단하는 경우"
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”의 승낙이 제12조 제1항의 수신확인통지형태로 이용자에게 도달한 시점에 계약이 성립한 것으로 봅니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ “몰”의 승낙의 의사표시에는 이용자의 구매 신청에 대한 확인 및 판매가능 여부, 구매신청의 정정 취소 등에 관한 정보 등을 포함하여야 합니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제11조(지급방법)")]),
          _vm._v(" "),
          _c("p", { staticClass: "titHtext" }, [
            _vm._v(
              "“몰”에서 구매한 재화 또는 용역에 대한 대금지급방법은 다음 각 호의 방법 중 가용한 방법으로 할 수 있습니다. 단, “몰”은 이용자의 지급방법에 대하여 재화 등의 대금에 어떠한 명목의 수수료도 추가하여 징수할 수 없습니다."
            )
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v("1. 폰뱅킹, 인터넷뱅킹, 메일뱅킹 등의 각종 계좌이체")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("2. 선불카드, 직불카드, 신용카드 등의 각종 카드 결제")
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("3. 온라인무통장입금")]),
            _vm._v(" "),
            _c("li", [_vm._v("4. 전자화폐에 의한 결제")]),
            _vm._v(" "),
            _c("li", [_vm._v("5. 수령 시 대금지급")]),
            _vm._v(" "),
            _c("li", [
              _vm._v("6. 마일리지 등 “몰”이 지급한 포인트에 의한 결제")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "7. “몰”과 계약을 맺었거나 “몰”이 인정한 상품권에 의한 결제"
              )
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("8. 기타 전자적 지급 방법에 의한 대금 지급 등")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [
            _vm._v("제12조(수신확인통지, 구매신청 변경 및 취소)")
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”은 이용자의 구매신청이 있는 경우 이용자에게 수신확인통지를 합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② 수신확인통지를 받은 이용자는 의사표시의 불일치 등이 있는 경우에는 수신확인통지를 받은 후 즉시 구매신청 변경 및 취소를 요청할 수 있고 “몰”은 배송 전에 이용자의 요청이 있는 경우에는 지체 없이 그 요청에 따라 처리하여야 합니다. 다만 이미 대금을 지불한 경우에는 제15조의 청약철회 등에 관한 규정에 따릅니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제13조(재화 등의 공급)")]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”은 이용자와 재화 등의 공급시기에 관하여 별도의 약정이 없는 이상, 이용자가 청약을 한 날부터 7일 이내에 재화 등을 배송할 수 있도록 주문제작, 포장 등 기타의 필요한 조치를 취합니다. 다만, “몰”이 이미 재화 등의 대금의 전부 또는 일부를 받은 경우에는 대금의 전부 또는 일부를 받은 날부터 3영업일 이내에 조치를 취합니다. 이때 “몰”은 이용자가 재화 등의 공급 절차 및 진행 사항을 확인할 수 있도록 적절한 조치를 합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”은 이용자가 구매한 재화에 대해 배송수단, 수단별 배송비용 부담자, 수단별 배송기간 등을 명시합니다. 만약 “몰”이 약정 배송기간을 초과한 경우에는 그로 인한 이용자의 손해를 배상하여야 합니다. 다만 “몰”이 고의·과실이 없음을 입증한 경우에는 그러하지 아니합니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제14조(환급)")]),
          _vm._v(" "),
          _c("p", { staticClass: "titHtext pdbNone" }, [
            _vm._v(
              "“몰”은 이용자가 구매신청한 재화 등이 품절 등의 사유로 인도 또는 제공을 할 수 없을 때에는 지체 없이 그 사유를 이용자에게 통지하고 사전에 재화 등의 대금을 받은 경우에는 대금을 받은 날부터 3영업일 이내에 환급하거나 환급에 필요한 조치를 취합니다."
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제15조(청약철회 등)")]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”과 재화 등의 구매에 관한 계약을 체결한 이용자는 「방문판매 등에 관한 법률」 및 「전자상거래 등에서의 소비자보호에 관한 법률」에 따라 청약철회를 할 수 있습니다. 해당 법률에 따르면, 계약내용에 관한 서면을 받은 날(그 서면을 받은 때보다 재화 등의 공급이 늦게 이루어진 경우에는 재화 등을 공급받거나 재화 등의 공급이 시작된 날을 말합니다)부터 ABO는 3개월, 소비자는 20일 이내에는 청약의 철회를 할 수 있습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② 이용자는 재화 등을 배송 받은 경우 다음 각 호의 1에 해당하는 경우에는 반품 및 교환을 할 수 없습니다.\n                                                "
              ),
              _c("ol", [
                _c("li", [
                  _vm._v(
                    "1. 이용자에게 책임 있는 사유로 재화 등이 멸실 또는 훼손된 경우(다만, 재화 등의 내용을 확인하기 위하여 포장 등을 훼손한 경우에는 청약철회를 할 수 있습니다.)"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "2. 이용자의 사용 또는 일부 소비에 의하여 재화 등의 가치가 현저히 감소한 경우"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "3. 시간의 경과에 의하여 재판매가 곤란할 정도로 재화 등의 가치가 현저히 감소한 경우"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "4. 같은 성능을 지닌 재화 등으로 복제가 가능한 경우 그 원본인 재화 등의 포장을 훼손한 경우"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "5. ABO의 경우, 재고 보유에 관하여 다단계판매업자에게 거짓으로 보고하는 등의 방법으로 과다하게 재화 등의 재고를 보유한 경우"
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ 제2항 제2호 내지 제4호의 경우에 “몰”이 사전에 청약철회 등이 제한되는 사실을 소비자가 쉽게 알 수 있는 곳에 명기하거나 시용상품을 제공하는 등의 조치를 하지 않았다면 이용자의 청약철회 등이 제한되지 않습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "④ 이용자는 제1항 및 제2항의 규정에 불구하고 재화 등의 내용이 표시·광고 내용과 다르거나 계약내용과 다르게 이행된 때에는 당해 재화 등을 공급받은 날부터 3월 이내, 그 사실을 안 날 또는 알 수 있었던 날부터 30일 이내에 청약철회 등을 할 수 있습니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [
            _vm._v("제16조(청약철회 등의 효과)")
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”은 이용자로부터 재화 등을 반환받은 경우 3영업일 이내에 이미 지급받은 재화 등의 대금을 환급합니다. 이 경우 “몰”이 이용자에게 재화 등의 환급을 지연한 때에는 그 지연기간에 대하여 「방문판매 등에 관한 법률」 및 「전자상거래 등에서의 소비자보호에 관한 법률 시행령」에서 정하는 지연이자율을 곱하여 산정한 지연이자를 지급합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”은 위 대금을 환급함에 있어서 이용자가 신용카드 또는 전자화폐 등의 결제수단으로 재화 등의 대금을 지급한 때에는 지체 없이 당해 결제수단을 제공한 사업자로 하여금 재화 등의 대금의 청구를 정지 또는 취소하도록 요청합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ “몰”은 이용자에게 청약철회 등을 이유로 위약금 또는 손해배상을 청구하지 않습니다. 다만 재화 등의 내용이 표시·광고 내용과 다르거나 계약내용과 다르게 이행되어 청약철회 등을 하는 경우 재화 등의 반환에 필요한 비용은 “몰”이 부담합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "④ 이용자가 재화 등을 제공받을 때 발송비를 부담한 경우에 “몰”은 청약철회 시 그 비용을 누가 부담하는지를 이용자가 알기 쉽도록 명확하게 표시합니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제17조(개인정보보호)")]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”은 이용자의 개인정보 수집시 서비스제공을 위하여 필요한 범위에서 최소한의 개인정보를 수집합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”은 회원가입시 구매계약이행에 필요한 정보를 미리 수집하지 않습니다. 다만, 관련 법령상 의무이행을 위하여 구매계약 이전에 본인확인이 필요한 경우로서 최소한의 특정 개인정보를 수집하는 경우에는 그러하지 아니합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ “몰”은 이용자의 개인정보를 수집·이용하는 때에는 당해 이용자에게 그 목적을 고지하고 동의를 받습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "④ “몰”은 수집된 개인정보를 목적외의 용도로 이용할 수 없으며, 새로운 이용목적이 발생한 경우 또는 제3자에게 제공하는 경우에는 이용·제공단계에서 당해 이용자에게 그 목적을 고지하고 동의를 받습니다. 다만, 관련 법령에 달리 정함이 있는 경우에는 예외로 합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "⑤ “몰”이 제3항과 제4항에 의해 이용자의 동의를 받아야 하는 경우에는 개인정보관리 책임자의 신원(소속, 성명 및 전화번호, 기타 연락처), 정보의 수집목적 및 이용목적, 제3자에 대한 정보제공 관련사항(제공받은자, 제공목적 및 제공할 정보의 내용) 등 「개인정보 보호법」 제39조가 규정한 사항을 미리 명시하거나 고지해야 하며 이용자는 언제든지 이 동의를 철회할 수 있습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "⑥ 이용자는 언제든지 “몰”이 가지고 있는 자신의 개인정보에 대해 열람 및 오류정정을 요구할 수 있으며 “몰”은 이에 대해 지체 없이 필요한 조치를 취할 의무를 집니다. 이용자가 오류의 정정을 요구한 경우에는 “몰”은 그 오류를 정정할 때까지 당해 개인정보를 이용하지 않습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "⑦ “몰”은 개인정보 보호를 위하여 이용자의 개인정보를 취급하는 자를 최소한으로 제한하여야 하며 신용카드, 은행계좌 등을 포함한 이용자의 개인정보의 분실, 도난, 유출, 동의 없는 제3자 제공, 변조 등으로 인한 이용자의 손해에 대하여 모든 책임을 집니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "⑧ “몰” 또는 그로부터 개인정보를 제공받은 제3자는 개인정보의 수집목적 또는 제공받은 목적을 달성한 때에는 당해 개인정보를 지체 없이 파기합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "⑨ “몰”은 개인정보의 수집·이용·제공에 관한 동의란을 미리 선택한 것으로 설정해두지 않습니다. 또한 개인정보의 수집·이용·제공에 관한 이용자의 동의거절시 제한되는 서비스를 구체적으로 명시하고, 필수수집항목이 아닌 개인정보의 수집·이용·제공에 관한 이용자의 동의 거절을 이유로 회원가입 등 서비스 제공을 제한하거나 거절하지 않습니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제18조(“몰”의 의무)")]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”은 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 이 약관이 정하는 바에 따라 지속적이고, 안정적으로 재화·용역을 제공하는데 최선을 다하여야 합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”은 이용자가 안전하게 인터넷 서비스를 이용할 수 있도록 이용자의 개인정보(신용정보 포함)보호를 위한 보안 시스템을 갖추어야 합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ “몰”이 상품이나 용역에 대하여 「표시·광고의 공정화에 관한 법률」 제3조 소정의 부당한 표시·광고행위를 함으로써 이용자가 손해를 입은 때에는 이를 배상할 책임을 집니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "④ “몰”은 이용자가 원하지 않는 영리목적의 광고성 전자우편을 발송하지 않습니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [
            _vm._v("제19조(회원의 ID 및 비밀번호에 대한 의무)")
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① 제17조의 경우를 제외한 ID와 비밀번호에 관한 관리책임은 회원에게 있습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② 회원은 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는 안됩니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ 회원이 자신의 ID 및 비밀번호를 도난 당하거나 제3자가 사용하고 있음을 인지한 경우에는 바로 “몰”에 통보하고 “몰”의 안내가 있는 경우에는 그에 따라야 합니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제20조(이용자의 의무)")]),
          _vm._v(" "),
          _c("p", { staticClass: "titHtext" }, [
            _vm._v("이용자는 다음 행위를 하여서는 안 됩니다.")
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [_vm._v("1. 신청 또는 변경시 허위 내용의 등록")]),
            _vm._v(" "),
            _c("li", [_vm._v("2. 타인의 정보 도용")]),
            _vm._v(" "),
            _c("li", [_vm._v("3. “몰”에 게시된 정보의 변경")]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "4. “몰”이 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("5. “몰” 기타 제3자의 저작권 등 지적재산권에 대한 침해")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "6. “몰” 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "7. 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 몰에 공개 또는 게시하는 행위"
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [
            _vm._v("제21조(연결“몰”과 피연결“몰” 간의 관계)")
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① 상위 “몰”과 하위 “몰”이 하이퍼 링크(예: 하이퍼 링크의 대상에는 문자, 그림 및 동화상 등이 포함됨)방식 등으로 연결된 경우, 전자를 연결 “몰”(웹 사이트)이라고 하고 후자를 피연결 “몰”(웹사이트)이라고 합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② 연결 “몰”은 피연결 “몰”이 독자적으로 제공하는 재화 및 용역에 의하여 이용자와 행하는 거래에 대해서 보증책임을지지 않는다는 뜻을 연결 “몰”의 사이트에서 명시한 경우에는 그 거래에 대한 보증책임을 지지 않습니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [
            _vm._v("제22조(저작권의 귀속 및 이용제한)")
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”이 작성한 저작물에 대한 저작권 기타 지적 재산권은 “몰” 귀속합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② 이용자는 “몰”을 이용함으로써 얻은 정보 중 “몰”에게 지적재산권이 귀속된 정보를 “몰”의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안됩니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ “몰”은 약정에 따라 이용자에게 귀속된 저작권을 사용하는 경우 당해 이용자에게 통보하여야 합니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제23조(분쟁해결)")]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”은 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상처리기구를 설치, 운영합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”은 이용자로부터 제출되는 불만사항 및 의견은 우선적으로 그 사항을 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 이용자에게 그 사유와 처리일정을 즉시 통보해 드립니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ “몰”과 이용자 간에 발생한 전자상거래 분쟁과 관련하여 이용자의 피해구제신청이 있는 경우에는 공정거래위원회 또는 시·도지사가 의뢰하는 분쟁조정기관의 조정에 따를 수 있습니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [
            _vm._v("제24조(재판권 및 준거법)")
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”과 이용자 간에 발생한 전자상거래 분쟁에 관한 소송은 제소 당시의 이용자의 주소에 의하고, 주소가 없는 경우에는 거소를 관할하는 지방법원의 전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자의 경우에는 민사소송법상의 관할법원에 제기합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”과 이용자 간에 제기된 전자상거래 소송에는 한국법을 적용합니다."
              )
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", [
        _vm._v(
          "본인은 암웨이 ABO 윤리강령 및 행동지침과 기타 규정을 준수함에 있어 그 형식뿐만 아니라 그 안에 내포된 진정한 정신까지 따를 것입니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "본인은 진실하고 정직한 태도로 암웨이 제품과 서비스, 그리고 사업 기회를 제시할 것이며, 암웨이가 공식적으로 제공한 자료에 명시된 사항만을 언급할 것입니다. 또한 암웨이의 제품이나 사업과 관련된 자료를 암웨이의 서면 승인 없이 제작하여 사용하지 않을 것이며, 암웨이 ABO에게 암웨이에서 제공하는 제품 및 서비스 이외의 기타 자료나 제품 및 사업을 홍보 또는 판매하지 않을 것입니다(디지털 커뮤니케이션에 따라 허용되는 경우는 제외)."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "본인은 고객의 불만에 대해 정중하고 신속하게 대응할 것이며, 반품 및 교환 요청에 대해서는 암웨이의 반품 절차 및 지침을 따를 것입니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "본인이 ABO로 등록된다고 해서 한국암웨이나 상위 후원자와 고용관계를 맺은 것은 아니며, 이들이 본인의 법적 대표자도 아니라는 사실을 인지하고 있습니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "본인은 암웨이 ABO로서 본인의 행동이 커다란 파급효과를 가져올 수 있다는 점을 인지하고 최고의 정직성과 책임감을 바탕으로 행동할 것이며, 암웨이 사업에 방해가 되거나 암웨이의 명예를 손상시키는 행위를 하지 않을 것입니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "본인은 암웨이 세일즈 & 마케팅 플랜과 ABO 윤리강령 및 행동지침에 규정된 ABO로서의 다양한 책임과 의무를 수용하고 실천할 것입니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "본인은 암웨이 ABO 윤리강령 및 행동지침과 관련 법규를 숙지하고 이의 모든 내용을 성실히 수행할 것에 동의하며, 이러한 제반 규정은 암웨이가 공식적으로 www.amway.co.kr 등을 통해 공지하거나 개별 통보함으로써 수시로 변경될 수 있으며 그러한 변경은 공지 또는 통보 시 명시된 적용일에 효력이 발생함에 동의합니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "본인은 신청서상에 기재된 후원자 사항에 한치의 오차도 없음을 확인합니다. 본인 또는 본인의 배우자가 이미 ABO로 등록되어 있는 경우 중복하여 가입할 수 없으며 예전에 ABO로 등록한 경험이 있었다면 ABO 자격이 해지된 날로부터 6개월이 경과하고 동 기간 중 일체의 판매나 암웨이사업 활동이 없었던 경우에만 다시 등록이 가능하다는 점을 주지하고 있으며 이에 근거하여 신청함을 확인합니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "본인은 암웨이 사업을 통해 얻은 정보를 암웨이의 사전 승인 없이 암웨이 사업 외의 목적으로 사용하지 않을 것이며, 타인의 개인 정보를 당사자의 허락 없이 이용하지 않을 것입니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "본인은 신청서에 기재된 내용에 한치의 오차도 없음을 확인하며, 만약 상기 사실을 위반하거나 본인의 활동이 암웨이 사업 또는 암웨이사에 심각한 피해를 입힌 경우 암웨이의 재량으로 본인의 ABO 자격을 해지할 수 있음에 동의합니다."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", [
        _vm._v("암웨이 ABO는 만 19세 이상의 성인만 신청할 수 있습니다.")
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "학생, 공무원, 교원은 한국암웨이 ABO로 등록할 수 없습니다. (단, 부모가 ABO로 등록되어 있는 학생의 경우 ABO 등록 가능)"
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "등록 후 최초 6개월 동안 일체의 주문 및 후원 활동이 없을 경우, ABO 자격은 해지될 수 있습니다. 다만, 해지 후 언제든지 ABO 등록이 가능합니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "ABO자격은 개인에 한해 부여되며 법인이나 단체에게는 허용되지 않습니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "공동 ABO는 법적 부부에 한해 부여되며, 부부는 반드시 하나의 ABO 번호만 가질 수 있습니다. 이미 배우자가 암웨이 ABO로 등록되어 있는 경우에는 ABO등록사항 변경 절차를 이용해 주십시오."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "ABO로 등록하여 후원수당이 발생한 경우, 본인 명의 계좌번호를 제출하여야 합니다. 1) 해당 후원수당 지급일 이전까지 본인 명의 계좌번호가 제출되지 아니한 경우 또는 2) 가입시 제출한 회원 정보와 제출된 계좌정보가 일치하지 않는 경우, 후원수당 지급이 보류될 수 있으며 주문 · 후원 등 일부 ABO 활동이 제한될 수 있습니다. 본인 명의 계좌번호 미제출 및 지연 제출로 인한 법률상 · 사업상의 모든 불이익은 ABO 본인의 책임임을 확인합니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          'ABO로 등록하여 소득이 발생할 경우 사업소득으로 원천징수 후 지급되며, 종합소득세의 신고 및 납부의 의무가 발생하게 됩니다. 원천징수 대상자는 본인의 주민등록번호를 한국암웨이에 제출하여야 합니다. 해당 후원수당 지급일 이전까지 주민등록번호가 제출되지 않은 경우 후원수당 지급이 보류될 수 있으며, 주민등록번호 미제출 및 지연 제출로 인하여 발생할 수 있는 법률상 · 사업상의 모든 불이익은 ABO 본인의 책임임을 확인합니다. 단, 국세청의 예규에 근거하여 매월 말 LOS기준으로 다운라인(하위판매원)이 없는 자가소비형 ABO의 후원수당은 비과세로 원천징수 대상에서 제외되며, 발급일 기준으로 다운라인이 없는 경우에 한해 "자가소비형 ABO 확인원"의 발급이 가능합니다.'
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "부가가치세법상 암웨이 ABO로 등록한 후 후원수당을 받기 위하여 물적시설(사업장 등)을 가지고 있거나, 근로자를 고용하고 사업을 하는 경우 사업자형 ABO로 구분되어 후원수당에 대해 연 2회 부가가치세 신고, 납부의 의무가 발생하게 됩니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "본인 또는 본인의 배우자가 이미 ABO로 등록되어 있는 경우 중복하여 가입할 수 없으며, 예전에 ABO로 등록한 경험이 있을 경우, ABO 자격이 상실된 날로부터 6개월이 경과하고 동 기간 중 일체의 판매나 암웨이 사업 활동이 없었던 경우에만 다시 ABO로 등록할 수 있습니다. 만일 본 조를 위반하여 ABO로 등록한 경우 한국암웨이는 해당 ABO 자격을 해지할 수 있습니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "ABO 등록 후 신청서상의 기재 내용에 변경이 발생한 경우, 변경사항을 즉시 암웨이에 알리고 정정해야 합니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "ABO 신청 또는 정보 변경 시 실명으로 모든 사항을 사실에 근거하여 작성하여야 하며, 허위 또는 타인의 정보를 등록할 경우 일체의 권리를 주장할 수 없습니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "ABO는 본인의 의사에 따라 암웨이에 탈퇴신청서를 제출하여 언제든지 탈퇴할 수 있으며, 탈퇴와 동시에 ABO로서의 모든 자격과 권한은 소멸됩니다. 탈퇴 시 ABO등록증 및 ABO 수첩을 한국암웨이에 제출하셔야 하며, 또한 ABO 탈퇴 후 등록된 공동사업자1 휴대폰 번호로 탈퇴 안내 문자 메세지가 전송됩니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "한국암웨이는 연간 정기 갱신제도를 시행하여, ABO 자격을 계속 유지하고자 할 경우 연간 정기 갱신 기간에 암웨이에 자격 갱신을 신청해야 합니다. ABO가 유효 만기일까지 자격 갱신을 신청하지 않은 경우, 또는 암웨이가 갱신 신청을 수락하지 않는 경우 해당 ABO의 자격과 해당 ABO에게 제공되던 혜택(A포인트, 현대카드 등)은 자동적으로 소멸됩니다. 자격 갱신 대상 및 절차는 매년 발표되는 한국암웨이의 공지 내용을 참조하시기 바랍니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "ABO 등록 신청자가 이전에 암웨이의 결정에 의해 ABO 자격을 상실한 적이 있는 경우, 또는 ABO로 등록하는 것이 관련 법규 및 암웨이 사업 운영에 현저한 지장을 줄 수 있다고 판단되는 경우, 암웨이는 ABO 등록 신청을 거부하거나 보류할 수 있습니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "가입절차상 ABO 등록 정보를 허위로 기재하거나 하자가 있는 경우 가입이 처리되지 않거나 가입후에도 사전 통보 없이 취소될 수 있습니다. 반드시 제출하시기 전에 기재사항을 다시 한번 확인해 주십시오."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v("외국인의 ABO 등록\n                      "),
        _c("p", { staticClass: "mgb0" }, [
          _vm._v(
            "외국인이 국내에서 ABO로 활동하기 위해서는 외국인이 다단계판매원으로 회원 가입, 활동할 수 있는 출입국 관리법상 적법한 비자를 소지하여야 하며 일정 서류를 한국암웨이㈜에 제출하여야 합니다. 출입국 관리법상 적법한 비자를 소지하지 않은 경우 본인이 출입국관리법에 따른 각종 법적 책임을 부담하게 되며, 가입 후 활동 불가 비자가 확인되는 경우에는 더 이상 ABO로서 활동할 수 없으며 탈퇴 조치됩니다."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "mgb0" }, [
          _vm._v(
            "- 등록시구비서류 : 외국인ABO 가입신청서 + 외국인 등록증 또는 국내 거소 신고증"
          )
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "listWarning mgt0" }, [
          _c("li", [
            _vm._v(
              "가입시 국내 체류 유효기간이 6개월 이상임이 확인되어야 합니다."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "신청서상의 기재사항이 불명확하거나 하자가 있는 경우 신청서 등록\n                        작업이 지연되거나 처리되지 않을 수 있습니다. 반드시 제출하시기 전에 기재사항을 다시 한 번 확인해주십시오."
            )
          ])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "mgt0" }, [
          _vm._v(
            "본인이 제출한 서류에 명시되어 있는 한국 체류 유효 기간이 만료되기 전, 체류 기간 연장을 증명하는 서류를\n                        한국암웨이㈜에 제출하여야 합니다. 이를 미 제출하는 경우에는 유효 기간 만료 익일에 ABO 자격이 해지됩니다. 재외국민,\n                        영주권자 등 대한민국 체류기간의 제한이 없는 분은 한국암웨이㈜가 요구하는 시점에 대한민국 체류자격 확인요청에 응하여야\n                        합니다."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "mgtS mgb0" }, [
          _c("strong", [_vm._v("[등록 가능한 외국인 체류 자격]")])
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _vm._v(
              "\n                          F-2(거주), F-2-1(한국인과 결혼한 외국인),\n                          F-2-3(영주자의 배우자), F-2-4(난민 인정을 받은 자), F-2-5(미화 50만 달러 이상 고액투자자),\n                          F-4(재외동포), F-5(영주), F-6, F-6-1, F-6-2, F-6-3(결혼이민)"
            ),
            _c("br"),
            _vm._v(
              "\n                          외국인이 ABO로 등록하여 후원수당이 발생한 경우, 외국인 등록번호 및 본인 명의 계좌번호를 제출하여야 합니다.\n                        "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                          1) 해당 후원수당 지급일 이전까지 외국인 등록번호 및 본인 명의 계좌번호가\n                            제출되지 아니한 경우 또는"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                          2) 가입시 제출한 회원정보와 외국인 등록정보 및 계좌정보가 일치하지 않는 경우, 후원수당 지급이 보류될 수 있으며 주문\n                          · 후원 등 일부 ABO 활동이 제한될 수 있습니다."
            ),
            _c("br"),
            _vm._v(
              " 외국인 등록 번호 및 본인 명의 계좌번호 미제출 또는\n                          지연 제출로 인한 법률상 · 사업상의 모든 불이익은 ABO 본인의 책임임을 확인합니다."
            ),
            _c("br"),
            _vm._v(
              " 외국인이 외국인\n                          자격으로 ABO로 가입하였으나, 대한민국 정부로부터 주민등록번호를 새로이 발급받은 경우, 후원수당 수령을 위해 본인의\n                          주민등록번호를 한국암웨이㈜에 제출하여야 합니다."
            ),
            _c("br"),
            _vm._v(
              " 해당 후원수당 지급일 이전까지 주민등록번호를 제출하지 않은\n                          경우, 후원수당 지급이 보류될 수 있으며, 주민등록번호 미제출 및 지연제출로 인하여 발생할 수 있는 세법상 등 각종\n                          불이익은 본인의 책임임을 확인합니다.\n                        "
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", [
        _vm._v(
          "재화등의 판매에 관한 계약의 체결을 강요하거나 청약철회등 또는 계약 해지를 방해할 목적으로 상대방을 위협하는 행위"
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "거짓 또는 과장된 사실을 알리거나 기만적 방법을 사용하여 상대방과의 거래를 유도하거나 청약철회등 또는 계약 해지를 방해하는 행위 또는 재화등의 가격·품질 등에 대하여 거짓 사실을 알리거나 실제보다도 현저히 우량하거나 유리한 것으로 오인시킬 수 있는 행위"
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "청약철회등이나 계약 해지를 방해할 목적으로 주소·전화번호 등을 변경하는 행위"
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "분쟁이나 불만 처리에 필요한 인력 또는 설비가 부족한 상태를 상당 기간 방치하여 상대방에게 피해를 주는 행위"
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "상대방의 청약이 없는데도 일방적으로 재화등을 공급하고 재화등의 대금을 청구하는 등 상대방에게 재화등을 강제로 판매하거나 하위판매원에게 재화등을 판매하는 행위"
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "소비자가 재화를 구매하거나 용역을 제공받을 의사가 없음을 밝혔는데도 전화, 팩스, 컴퓨터통신 등을 통하여 재화를 구매하거나 용역을 제공받도록 강요하는 행위"
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "다단계판매업자에게 고용되지 아니한 다단계판매원을 다단계판매업자에게 고용된 사람으로 오인하게 하거나 다단계판매원으로 등록하지 아니한 사람을 다단계판매원으로 활동하게 하는 행위"
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "방문판매등에 관한 법률 제37조에 따른 소비자피해보상보험계약등을 체결하지 아니하고 영업하는 행위"
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "상대방에게 판매하는 개별 재화등의 가격을 대통령령으로 정하는 금액인 160만원(부가가치세포함)을 초과하도록 정하여 판매하는 행위"
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "본인의 허락을 받지 아니하거나 허락받은 범위를 넘어 소비자에 관한 정보를 이용하는 행위"
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v("다단계판매조직 및 다단계판매원의 지위를 양도·양수하는 행위")
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "재화등의 거래 없이 금전거래를 하거나 재화등의 거래를 가장하여 사실상 금전거래만을 하는 행위"
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "판매원 또는 판매원이 되려는 자에게 하위판매원 모집 자체에 대하여 경제적 이익을 지급하거나 정당한 사유 없이 후원수당 외의 경제적 이익을 지급하는 행위"
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "방문판매등에 관한 법률 제20조 제3항에 위반되는 후원수당의 지급을 약속하여 판매원을 모집하거나 가입을 권유하는 행위"
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "판매원 또는 판매원이 되려는 자에게 가입비, 판매 보조 물품, 개인 할당 판매액, 교육비 등 그 명칭이나 형태와 상관없이 5만원 이하로서 대통령령으로 정하는 수준을 초과한 비용 또는 그 밖의 금품을 징수하는 등 의무를 부과하는 행위"
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "판매원에 대하여 상품권을 판매하는 행위로서 다음 각 목의 어느 하나에 해당하는 행위\n                                    "
        ),
        _c("ul", [
          _c("li", [
            _vm._v(
              "가. 판매업자가 소비자에게 판매한 상품권을 다시 매입하거나 다른 자로 하여금 매입하도록 하는 행위"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "나. 발행자등의 재화등의 공급능력, 소비자에 대한 재화등의 공급실적, 상품권의 발행규모 등에 비추어 그 실질이 재화등의 거래를 위한 것으로 볼 수 없는 수준의 후원수당을 지급하는 행위"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "사회적인 관계 등을 이용하여 다른 사람에게 자신의 하위판매원으로 등록하도록 강요하거나 그 하위판매원에게 재화등을 구매하도록 강요하는 행위"
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "판매원 또는 판매원이 되려는 사람에게 본인의 의사에 반하여 교육·합숙 등을 강요하는 행위"
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "판매원을 모집하기 위한 것이라는 목적을 명확하게 밝히지 아니하고 취업·부업 알선, 설명회, 교육회 등을 거짓 명목으로 내세워 유인하는 행위"
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "다른 다단계 판매원에게 일정수의 하위판매원을 모집하도록 의무를 지게 하거나, 특정인을 그의 동의 없이 자신의 하위판매원으로 등록시키는 행위"
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "국가공무원, 지방공무원, 교육공무원 및 교원으로서 다단계 판매원으로 가입하는 행위"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "scroll-table" }, [
      _c("table", { staticClass: "tbl-type1 line-st" }, [
        _c("caption", [
          _vm._v(
            "ABO 등록 사항 변경을 보여주는 표 : 내용, 구비서류, 방법, 비고"
          )
        ]),
        _vm._v(" "),
        _c("colgroup", [
          _c("col", { staticStyle: { width: "15%" } }),
          _vm._v(" "),
          _c("col", { staticStyle: { width: "51%" } }),
          _vm._v(" "),
          _c("col", { staticStyle: { width: "14%" } }),
          _vm._v(" "),
          _c("col", { staticStyle: { width: "20%" } })
        ]),
        _vm._v(" "),
        _c("thead", [
          _c("tr", [
            _c("th", { attrs: { scope: "col" } }, [_vm._v("내용")]),
            _vm._v(" "),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("구비서류")]),
            _vm._v(" "),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("방법")]),
            _vm._v(" "),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("비고")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("ABO 갱신")]),
            _vm._v(" "),
            _c("td", { staticClass: "textL" }, [
              _c("ul", { staticClass: "listDash" }, [
                _c("li", [
                  _vm._v(
                    "한국암웨이 ABO 갱신 계약 동의서, 신분증 사본(A&B 등록 시 A, B 모두의 신분증 사본)"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "대리인 접수 시: 한국암웨이 ABO 갱신 계약 동의서, 신분증 사본, 통장사본(온라인통장 사본 제외), 대리인 신분증 사본, 위임장 (갱신계약 동의서와 위임장 상에 날인된 도장(서명)이 통장사본의 도장(서명)과 일치해야함)"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "갱신 철회 및 포기 접수 시: 갱신 철회/포기 요청서, 신분증 사본(부부 등록 ABO의 경우, 두분 모두의 서류 제출)"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "갱신 철회 및 포기 대리인 접수 시: 갱신 철회/포기 요청서, 신분증 사본, 위임장(도장/사인 확인), 대리인 신분증 사본 온라인/ABC  갱신철회, 갱신포기 본인/대리인 접수 모두 가능(2012년 부터) 단, 현장접수만 가능(우편접수불가)"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "단 번복 행위인 갱신철회 취소, 갱신포기 취소는 본인만 가능 (대리접수불가)"
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("온라인/ABC")]),
            _vm._v(" "),
            _c("td", { staticClass: "textL" }, [
              _c("ul", { staticClass: "listDash" }, [
                _c("li", [
                  _vm._v(
                    "갱신철회, 갱신포기 본인/대리인 접수 모두 가능(2012년 부터) 단, 현장접수만 가능(우편접수불가)"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "단 번복 행위인 갱신철회 취소, 갱신포기 취소는 본인만 가능 (대리접수불가)"
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("ABO 탈퇴")]),
            _vm._v(" "),
            _c("td", { staticClass: "textL" }, [
              _c("ul", { staticClass: "listDash" }, [
                _c("li", [
                  _vm._v(
                    "ABO 탈퇴 요청서(A&B 등록 시 A, B 모두의 탈퇴서), 신분증 사본(A&B 등록 시 A, B 모두의 신분증 사본) 제출 필수, 암웨이 발행 ABO 등록증 및 ABO 수첩 (분실 시 탈퇴서에 분실 확인 작성)"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "대리인 접수 시: 대리인 신분증 사본/위임장(도장/사인 확인) 추가"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "온라인으로 본인 확인 후 탈퇴 가능(A&B 모두 본인 확인 필수)"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "사망한 ABO(공동사업자1만 등록된 경우)의 탈퇴 시: ABO 사망확인서, 가족관계증명서, 상속 가능한 가족 전체의 상속포기동의서, 상속자 대표 1인의 탈퇴서, 신분증 사본(ABOship의 상속 권한이 있는 사람들의 동의하에 탈퇴 가능) 대리인 접수 시, 상속자 대표 1인의 위임장, 대리인 신분증 사본 추가"
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("온라인/ABC/팩스")]),
            _vm._v(" "),
            _c("td", { staticClass: "textL" }, [
              _c("ul", { staticClass: "listDotFS" }, [
                _c("li", [
                  _vm._v("탈퇴 후 6개월간 ABO등록이 불가(6개월비활동규정)")
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("Member탈퇴는 온라인에서만 가능")])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [
              _vm._v("성명/주민번호/생년월일/주소변경")
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "textL" }, [
              _c("ul", { staticClass: "listDash" }, [
                _c("li", [
                  _vm._v(
                    "ABO 정보변경 요청서, 신분증, 통장 사본(변경된 주민등록번호/생년월일/성명으로 발급된 통장) 제출"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "주민등록번호 변경은 기존에 주민등록번호가 등록되어 있는 경우에 한해 진행"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "성명, 주민등록번호, 생년월일 동시 변경 시 위 서류와 함께 주민등록 초본 또는 등본(최근 3개월 이내 발행된 서류로 뒷자리까지 모두 표기)을 첨부 바랍니다(등본은 대상자 이외 다른 개인정보는 마스킹 처리)."
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "통장사본은 기존에 보너스 계좌 정보가 등록되어 있고 수정을 원하시는 경우에 한 해 제출이 필요하며, 별도 요청이 없는 경우 기존에 등록되어 있는 보너스 계좌는 삭제되어 재등록이 필요합니다."
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "대리 접수 시 첨부서류: 변경 요청자 신분증 사본, 통장 사본(온라인통장 제외/계좌 변경 요청 시에 한해), 위임장(통장 서명/도장 일치 확인), 대리인 신분증"
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("온라인/ABC/팩스")]),
            _vm._v(" "),
            _c("td", { staticClass: "textL" }, [
              _c("ul", { staticClass: "listDash" }, [
                _c("li", [
                  _vm._v("ABO 등록사항변경 요청서 (개인정보관련) 양식 활용")
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("온라인은 주소만 변경 가능")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "주민등록번호/보너스 계좌번호 변경은 이미 등록되어 있는 ABO만 변경이 가능함"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "주민등록초본 제출이 어려운 경우, 주민등록등본으로 대체 가능하며, 본인 이외 다른 개인정보는 마스킹처리하여 접수"
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [
              _vm._v("통장변경/미지급보너스 통장변경")
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "textL" }, [
              _c("ul", { staticClass: "listDash" }, [
                _c("li", [
                  _vm._v(
                    "ABO 정보변경 요청서, 신분증 지참, 통장사본(도장/서명 확인)"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "대리인 접수 시: 신분증 사본/위임장(통장 도장/사인 일치 확인) 추가"
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("온라인/ABC/팩스")]),
            _vm._v(" "),
            _c("td", { staticClass: "textL" }, [
              _c("ul", { staticClass: "listDash" }, [
                _c("li", [
                  _vm._v("ABO 등록사항변경 요청서 (개인정보관련) 양식 활용")
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [
              _vm._v("자동이체 계좌등록")
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "textL" }, [
              _c("ul", { staticClass: "listDash" }, [
                _c("li", [
                  _vm._v(
                    "자동이체 신청서, 신분증 지참, 통장사본(도장/서명 확인)"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "대리인 접수 시: 대리인 신분증 지참/위임장(통장 도장/서명 일치 확인) 추가"
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("온라인/ABC")]),
            _vm._v(" "),
            _c("td", { staticClass: "textL" }, [
              _c("ul", { staticClass: "listDash" }, [
                _c("li", [
                  _vm._v("자동이체계좌 변경은 기존 체결계좌를 해지 후 신청")
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [
              _vm._v("배우자 (공동사업자1) 순서변경 (A&B → B&A)")
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "textL" }, [
              _vm._v(
                "ABO 등록사항변경 요청서\n                                                "
              ),
              _c("ul", { staticClass: "listDash" }, [
                _c("li", [
                  _vm._v(
                    "A 방문 시 : A-신분증 지참& B-신분증 사본, 공동사업자 등록/변경/삭제 요청서(도장/서명 확인), B 통장 사본"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "B 또는 제3자 대리인 접수 시 : B 신분증지참&A 신분증 사본, A 인감 증명서 원본, 공동사업자 등록/변경/삭제 요청서(A 인감도장 확인_인감증명서 도장과 일치해야함), B 통장 사본, 제3자 대리인 신분증 사본, 위임장(A인감도장 날인) 반드시 제출"
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("ABC")]),
            _vm._v(" "),
            _c("td", { staticClass: "textL" }, [
              _c("ul", { staticClass: "listDash" }, [
                _c("li", [
                  _vm._v("ABO 등록사항 변경요청서 (공동사업자 관련) 양식 활용")
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("인감증명서는 원본 접수만 가능")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("B 또는 제3자 대리 접수: 동의서+위임자에 A인감날인")
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("배우자 추가")]),
            _vm._v(" "),
            _c("td", { staticClass: "textL" }, [
              _c("ul", { staticClass: "listDash" }, [
                _c("li", [
                  _vm._v(
                    "공동사업자 등록/변경/삭제 요청서, AB 신분증 사본, 개인정보처리동의서 (등록사항변경요청서 뒷장에 첨부되어 있음)"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "부부 입증 서류(배우자/처/결혼이라 명시된 서류): 최근 3개월이내 발급된 혼인관계증명서 또는 가족관계증명서 또는 주민등록등본\n                                                        "
                  ),
                  _c("p", [
                    _vm._v(
                      "부부가 주소가 같을 시: 혼인관계 증명서 또는 가족관계증명서 또는 주민등록 등본"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "부부가 주소가 다를 시: 혼인관계 증명서 또는 가족관계증명서"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("결혼으로 인한 추가 시: 혼인관계 증명서")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "대리인 접수 시: 대리인 신분증 지참, 위임장(도장/서명 확인) 추가"
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("ABC/팩스")]),
            _vm._v(" "),
            _c("td", { staticClass: "textL" }, [
              _c("ul", { staticClass: "listDash" }, [
                _c("li", [
                  _vm._v("ABO 등록사항 변경요청서 (공동사업자 관련) 양식 활용")
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("“배우자”, “처”, “결혼”이라 명시된 서류만 가능")
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "공무원/교원여부와 부부 이중등록 확인 절차 강화로 배우자 추가시의 시일이 다소 소요됨"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("배우자 추가시 개인정보 처리동의서 반드시 제출")
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [
              _vm._v("배우자 삭제 A&B → A (B삭제)")
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "textL" }, [
              _c("ul", { staticClass: "listDash" }, [
                _c("li", [_vm._v("공동사업자 등록/변경/삭제 요청서")]),
                _vm._v(" "),
                _c("li", [_vm._v("B가 서류 접수 시: B 신분증 지참")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "A 또는 제3자 대리인 접수 시: AB 신분증 사본, B 인감 증명서 원본, 위임장(위임 내용/B 인감도장 확인), 제3자 대리인 신분증 사본\n                                                        "
                  ),
                  _c("p", [
                    _vm._v(
                      "이혼으로 배우자 삭제를 희망한다는 문의가 있을 경우 (본인_삭제자): 일반 배우자 삭제 절차를 안내하고, 삭제된 배우자가 추후 신규등록을 희망할 경우에는 혼인관계 증명서 제출이 필요하며 윤리강령부 심의 후 등록이 승인됨"
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("ABC")]),
            _vm._v(" "),
            _c("td", { staticClass: "textL" }, [
              _c("ul", { staticClass: "listDash" }, [
                _c("li", [
                  _vm._v("ABO 등록사항 변경요청서 (공동사업자 관련) 양식 활용")
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("인감증명서는 원본 접수만 가능")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "A 또는 제3자 대리 접수: 배우자(공동사업자2 B) 삭제 동의서 + 위임장에 B인감 날인"
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [
              _vm._v("배우자 삭제 A&B → B (A삭제)")
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "textL" }, [
              _c("ul", { staticClass: "listDash" }, [
                _c("li", [_vm._v("공동사업자 등록/변경/삭제 요청서")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "A가 서류 접수 시: A-신분증 지참, B 신분증 사본, B 통장 사본"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "B 또는 제3자 대리인 접수 시: A, B 모두의 신분증 필요(A-신분증 사본), A 인감증명서 원본, 위임장(A 인감도장 확인), B 통장 사본/제3자 대리인 신분증 사본"
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("ABC")]),
            _vm._v(" "),
            _c("td", { staticClass: "textL" }, [
              _c("ul", { staticClass: "listDash" }, [
                _c("li", [
                  _vm._v("ABO 등록사항 변경요청서 (공동사업자 관련) 양식 활용")
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("인감증명서는 원본 접수만 가능")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "B 또는 제3자 대리 접수: 배우자(공동사업자1 A) 삭제 동의서 + 위임장에 A인감 날인"
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [
              _vm._v("이혼으로 인한 삭제자의 신규등록")
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "textL" }, [
              _c("ul", { staticClass: "listDash" }, [
                _c("li", [
                  _vm._v(
                    "ABO 등록 심사 신청서, 혼인관계증명서, 규정 준수 확인서(본인 & 신규등록 스폰서 서명 혹은 날인)"
                  )
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("대리인 접수 시: 신분증, 위임장 추가")])
              ])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("ABC")]),
            _vm._v(" "),
            _c("td", { staticClass: "textL" }, [
              _c("ul", { staticClass: "listDotFS" }, [
                _c("li", [
                  _vm._v("배우자 삭제일로부터 6개월 비활동 규정 준수")
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("온라인 등록 불가")]),
                _vm._v(" "),
                _c("li", [_vm._v("윤리강령 심의 후 가능")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("윤리강령 승인 후 30일 이내 온라인에서 등록 가능")
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [
              _vm._v("사망으로 인한 배우자 삭제")
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "textL" }, [
              _c("ul", { staticClass: "listDash" }, [
                _c("li", [
                  _vm._v(
                    "공동사업자2 미등록 상태에서 ABO 사망 후:\n                                                        "
                  ),
                  _c("ul", { staticClass: "listDashFS" }, [
                    _c("li", [
                      _vm._v(
                        "사망신고전: 사망자의 인감증명서 원본이 있으면 배우자 대리 접수로 처리 (인감증명원본이 없으면 아래와 같이 사망신고후 상속 처리)"
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [_vm._v("사망신고후: 상속 진행")])
                  ])
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "A&B 등록 상태에서 1인 사망 시 남아있는 배우자에게 ABO 자격 귀속 (단, 사망 3개월 이내에 사망확인서 제출)\n                                                        "
                  ),
                  _c("ul", { staticClass: "listDashFS" }, [
                    _c("li", [
                      _vm._v(
                        "o A 사망 시: 배우자를 공동사업자1로 변경 처리 (사망진단서, 공동사업자 등록/변경/삭제 요청서, B 신분증 지참, B 통장사본)"
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(
                        "o B 사망 시: 배우자 삭제로 처리 (사망진단서, 공동사업자 등록/변경/삭제 요청서, A 신분증 지참)"
                      )
                    ])
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("ABC")]),
            _vm._v(" "),
            _c("td", { staticClass: "textL" }, [
              _c("ul", { staticClass: "listDash" }, [
                _c("li", [
                  _vm._v("ABO 등록사항 변경요청서 (공동사업자 관련) 양식 활용")
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "txt-italic" }, [
      _vm._v("FAX,우편은 기본적으로 고객센터의 FAX, 우편을 의미합니다."),
      _c("br"),
      _vm._v(
        "\n                                FAX,우편 접수건은 접수 처리 후 전화하여 처리 완료 안내할 때 본인 확인함(본인확인시 생년월일, 연락처, 주소 확인. 일치하지 않는 경우 등록된 은행명으로 추가 확인)"
      ),
      _c("br")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "scroll-table" }, [
      _c("table", { staticClass: "tbl-type1 line-st" }, [
        _c("caption", [
          _vm._v(
            "개인정보 수집/이용 동의서 현황을 보여주는 표 : 구분, 목적, 항목"
          )
        ]),
        _vm._v(" "),
        _c("thead", [
          _c("tr", [
            _c("th", { attrs: { scope: "col" } }, [_vm._v("구분")]),
            _vm._v(" "),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("목적")]),
            _vm._v(" "),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("항목")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("고유식별정보")]),
            _vm._v(" "),
            _c("td", [_vm._v("후원수당 발생 시, 수집 및 이용")]),
            _vm._v(" "),
            _c("td", [_vm._v("주민등록번호, 외국인등록번호")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("필수정보")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n                                                서비스 이용에 따른 본인 식별, 각종 서비스 관련 고지사항 전달"
              ),
              _c("br"),
              _vm._v(
                "\n                                                고객 상담 (제품 A/S 접수 및 처리포함), 불만 및 민원처리"
              ),
              _c("br"),
              _vm._v(
                "\n                                                사업자 윤리강령 소정의 스폰서십 라인 규정 준수 확인"
              ),
              _c("br"),
              _vm._v(
                "\n                                                청구서 등 각종 관련 서류 및 주문 물품 배송"
              ),
              _c("br"),
              _vm._v(
                "\n                                                물품구입에 따른 요금결제, 반품/환불, 세금 신고"
              ),
              _c("br"),
              _vm._v(
                "\n                                                서비스 및 제품 품질 향상을 위한 활용"
              ),
              _c("br"),
              _vm._v(
                "\n                                                사업자 후원수당 제공"
              ),
              _c("br"),
              _vm._v(
                "\n                                                기타 ABO 사업관리 및 서비스 지원\n                                            "
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _c("ul", [
                _c("li", [
                  _vm._v("- "),
                  _c("b", [_vm._v("회원가입 시:")]),
                  _c("br"),
                  _vm._v(
                    " ABO 공동사업자1: 성명, 회원ID, 비밀번호, 생년월일, 성별, 이메일, 주소, 휴대폰번호"
                  ),
                  _c("br"),
                  _vm._v(
                    " ABO공동사업자2 (공동사업자 등록의 경우): 성명, 생년월일, 성별, 휴대폰번호"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("- "),
                  _c("b", [_vm._v("주문/거래 시:")]),
                  _c("br"),
                  _vm._v(
                    " 신용카드정보(카드 주문 시), 은행계좌정보 (무통장 입금 시), 주문/거래 기록"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("- "),
                  _c("b", [_vm._v("서비스 이용 시:")]),
                  _c("br"),
                  _vm._v(
                    " 서비스 이용기록, 이용정지 기록, 이용해지 기록, 접속로그, 쿠키(Cookie), 접속 IP, 국가"
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { scope: "row", rowspan: "3" } }, [
              _vm._v("선택정보")
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n                                                고객 상담 및 응대"
              ),
              _c("br"),
              _vm._v(
                "\n                                                고객 불만 접수 및 민원처리"
              ),
              _c("br"),
              _vm._v(
                "\n                                                고지사항 전달"
              ),
              _c("br"),
              _vm._v(
                "\n                                                물품 배송\n                                            "
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _c("ul", [
                _c("li", [
                  _vm._v(
                    "- ABO: 공동사업자1 집 전화번호, 받는 분 성명, 받는 분 주소, 집 전화번호 또는 휴대폰 (배송지 관리 메뉴 이용 시)"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "- Amway Wallet, 현대카드 발급 시: CI(외부연계 식별정보), DI (중복가입 확인정보)"
                  )
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("- 은행계좌번호 (사업자 후원수당 제공 시)")])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _vm._v(
                "ABO 대상의 공식 행사, 이벤트, 교육 등에 참석 시 수집되는 영상물 정보는 당사 운영 온라인 (인터넷 모바일) 웹사이트 및 Apps 게재 , 발간하는 인쇄물 게재, 사내 웹사이트 게재, 언론사 홍보기사 게재, 기타 YouTube, Webzine 게재, 기타 회사에서 배포하는 홍보물(미디어 파일, 인쇄물, 스마트 TV 등 매체를 통해 전달되는 컨텐츠)의 제작에 활용될 수 있습니다."
              )
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("ABO 영상물(사진, 동영상)정보")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("제품소개, 프로모션, 이벤트 안내")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "카카오프로필 (닉네임/프로필 사진), 전화번호, 이메일, 생년월일, 성별"
              )
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mgtS" }, [
      _c("p", { staticClass: "titHtext" }, [_vm._v("(공통) 이용·보유기간")]),
      _vm._v(" "),
      _c("p", { staticClass: "titHtext" }, [
        _vm._v("회원탈퇴 시까지 보관"),
        _c("br"),
        _vm._v(
          "\n                                    단, 회사 내부 방침 및 관련 법령에 의해 보관하여야 할 경우 아래와 같이 이용 및 보유함."
        )
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "box_list-indent" }, [
        _c("li", { staticClass: "mgtS" }, [
          _vm._v("1. 소비자 기본법\n                                        "),
          _c("p", [
            _vm._v(
              "- 사후관리(A/S, 부품교체 및 정보 제공 등)의 목적으로 개인정보, 구매정보, 정수기 및 공기청정기 부품교체 정보에 관한 기록: "
            ),
            _c(
              "strong",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [_vm._v("7년")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "mgtS" }, [
          _vm._v(
            "2. 전자상거래 등에서의 소비자 보호에 관한 법률\n                                        "
          ),
          _c("p", [
            _vm._v("- 표시, 광고에 관한 기록: "),
            _c(
              "strong",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [_vm._v("6개월")]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "- 계약 또는 청약철회 등의 대금결제 및 재화 등의 공급에 관한 기록: "
            ),
            _c(
              "strong",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [_vm._v("5년")]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("- 소비자의 불만 또는 분쟁처리에 관한 기록: "),
            _c(
              "strong",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [_vm._v("3년")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "mgtS" }, [
          _vm._v("3. 통신비밀보호법\n                                        "),
          _c("p", [
            _vm._v("- 이용자의 인터넷 등 로그기록: "),
            _c(
              "strong",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [_vm._v("3개월")]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("- 이용자의 접속지 추적자료 그 외의 통신사실 확인 자료: "),
            _c(
              "strong",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [_vm._v("1년")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "mgtS" }, [
          _vm._v(
            "4. 회사 내부 방침에 의한 정보보유 사유\n                                        "
          ),
          _c("p", [
            _vm._v("- 부정이용기록: "),
            _c(
              "strong",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [_vm._v("사업 종료 시까지")]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "- ABO 윤리강령 소정의 스폰서십 라인 규정 준수 확인을 위한 기록: "
            ),
            _c(
              "strong",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [_vm._v("2년")]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "- 콜센터 및 홈페이지, 챗봇 채팅 서비스를 통한 A/S 접수/상담 시 수집된 개인정보: "
            ),
            _c(
              "strong",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [_vm._v("7년")]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "- 제품 A/S, 교환, 환불, 홈페이지 상 소모품 구매 시 수집된 개인정보: "
            ),
            _c(
              "strong",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [_vm._v("7년")]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "- 홈페이지 이메일 문의, 고객의 소리 이용 시 수집된 개인정보: "
            ),
            _c(
              "strong",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [_vm._v("3년")]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "mgtS",
        staticStyle: {
          "border-top": "1px solid rgb(218, 218, 218)",
          "padding-top": "10px"
        }
      },
      [
        _c("p", [
          _vm._v("더 자세한 내용에 대해서는 한국암웨이 주식회사 "),
          _c(
            "a",
            {
              staticStyle: { color: "blue", "text-decoration": "underline" },
              attrs: { href: "https://www.amway.co.kr/compliance/info-policy" }
            },
            [_vm._v("개인정보처리방침")]
          ),
          _vm._v("을 참고하시기 바랍니다.")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "scroll-table mgtS" }, [
      _c("table", { staticClass: "tbl-type1 line-st" }, [
        _c("caption", [
          _vm._v(
            "개인정보 제 3자 제공에 대한 동의 현황을 보여주는 표 : 제공받는 자, 이용목적, 제공항목, 보유기간"
          )
        ]),
        _vm._v(" "),
        _c("thead", [
          _c("tr", [
            _c("th", { attrs: { scope: "col" } }, [_vm._v("제공받는 자")]),
            _vm._v(" "),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("이용목적")]),
            _vm._v(" "),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("제공항목")]),
            _vm._v(" "),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("보유 및 이용기간")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c(
              "td",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [
                _vm._v(
                  "본인이 속한 ABO 그룹 스폰서 및 LOS상의 동 그룹 내 상의 ABO"
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "td",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [
                _vm._v(
                  "ABO 조직관리, 제품정보 등의 DM 발송, 교육, 유선 상담, 체험프로그램 제공"
                )
              ]
            ),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "회원번호, 이름, 주소, 전화번호, 실적, 주문 및 반품 내역 (제품명, 결제방법, 거래명세 확인, 배송지 확인, 주문 처리 및 취소여부, 환불 여부), 미수금 여부"
              )
            ]),
            _vm._v(" "),
            _c(
              "td",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [_vm._v("서비스 제공 종료 시까지 또는 동의 철회 시까지")]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mgtS" }, [
      _c("p", { staticClass: "titHtext" }, [
        _vm._v(
          "* 본인이 속한 ABO 그룹 스폰서 및 LOS상의 동 그룹 내 상위 ABO (제공받는 자)는 가입완료 후 마이페이지에서 확인할 수 있습니다. "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "titHtext" }, [
        _vm._v(
          "* 본 제3자 정보제공동의를 거부할 수 있습니다. 만일, 거부하더라도, 일체의 불이익은 없습니다."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "scroll-table mgtS" }, [
      _c("table", { staticClass: "tbl-type1 line-st" }, [
        _c("caption", [
          _vm._v(
            "마케팅/홍보 목적의 개인정보 수집 및 이용동의 현황을 보여주는 표 : 구분, 목적, 항목, 이용보유기간"
          )
        ]),
        _vm._v(" "),
        _c("thead", [
          _c("tr", [
            _c("th", { attrs: { scope: "col" } }, [_vm._v("구분")]),
            _vm._v(" "),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("목적")]),
            _vm._v(" "),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("항목")]),
            _vm._v(" "),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("보유 및 이용기간")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("광고성 정보 수신")]),
            _vm._v(" "),
            _c("td", [_vm._v("제품소개, 프로모션, 이벤트 안내")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "카카오 프로필 (닉네임/프로필사진), 전화번호, 이메일, 생년월일, 성별"
              )
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("동의철회시 / 회원탈퇴시")])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box_compliance-agree" }, [
      _c("p", { staticClass: "txt-italic" }, [
        _vm._v("[선택] 마케팅 홍보 목적의 이메일 수신동의")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "txt-italic" }, [
        _vm._v("[선택] 마케팅 홍보 목적의 SMS 수신동의")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mgtS" }, [
        _vm._v("* [선택] 항목은 동의하지 않더라도 가입이 가능합니다.")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mgtS" }, [
        _vm._v(
          "* '마케팅/혜택 정보 수신' 동의를 철회하시면 본 목적으로서의 개인 정보 처리는 중지됩니다."
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e439bc8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e439bc8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/amwayterms/termsAbo.vue
// module id = null
// module chunks = 